export default __webpack_public_path__ + "static/spectrocoin-blog-logo-feba9594d79e9923c371b5684e4fbbc0.svg";